import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

// order History calendar field
dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: block;
                    div[class^="FormFieldStyle"] {
                        padding: 10px 0px 10px 0px;
                        width: 100%;
                    }
                `,
                css`
                    display: block;
                    div[class^="FormFieldStyle"] {
                        padding: 10px 0px 10px 0px;
                        width: 100%;
                    }
                `,
                css`
                    display: block;
                    div[class^="FormFieldStyle"] {
                        padding: 10px 0px 10px 0px;
                        width: 100%;
                    }
                `,
                css`
                    div[class^="DateTimePickerStyle"] {
                        > div {
                            padding: 2px 4px 2px 2px;
                        }
                        > div:focus-within {
                            padding: 2px 4px 2px 2px;
                        }
                    }
                `,
                null,
            ])}
    `,
};

dateRangeStyles.fromDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                margin-right: 5px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                margin-right: 12px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                    margin-right: 5px;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                margin-right: 12px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                    margin-right: 5px;
                                }
                            }
                        }
                    `,
                ])}
        `,
        formField: css`
            padding-right: 10px;
        `,
    },
};

dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                    margin-right: 5px;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                margin-right: 12px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                    margin-right: 5px;
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="react-datetime-picker"] {
                            > button {
                                width: 34px;
                                margin-right: 12px;
                                > span[class^="IconWrapper"] {
                                    width: 34px;
                                    height: 36px;
                                    border-radius: 100%;
                                    background: none;
                                    margin-right: 5px;
                                }
                            }
                        }
                    `,
                ])}
        `,
        formField: css`
            padding-left: 10px;
        `,
    },
    labelProps: {
        color: "text.main",
    },
};
